import React from 'react';

import type { SharedCollectionListItem } from 'collections/types';
import type { ColumnRenderers } from 'components/common/EntityDataTable';
import CollectionTitleCell from 'collections/components/common/cells/CollectionTitleCell';

const customColumnRenderers: ColumnRenderers<SharedCollectionListItem> = {
  attributes: {
    title: {
      renderCell: (title: SharedCollectionListItem['title'], collection: SharedCollectionListItem) => (
        <CollectionTitleCell title={title} id={collection.id} />
      ),
    },
  },
};

export default customColumnRenderers;
